import { memo } from 'react';
import { googleTranslateElementWrapperId } from 'volto-google-translate/constants';

const Wrapper = memo(function Element() {
  return (
    <div>
      <div id={googleTranslateElementWrapperId} />
    </div>
  );
});

// Sorry about the div soup, but React is hyper-agressive at replacing the
//   element with the id which causes the translation to stop working.
export function GoogleTranslatePlaceholder() {
  return (
    <div>
      <Wrapper />
    </div>
  );
}
